import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { SoilType, SoilTypeState } from 'src/app/shared/models';

import { SoilTypeActions, SoilTypeActionTypes } from '../actions/soil-type.actions';

export const adapter: EntityAdapter<SoilType> = createEntityAdapter<SoilType>();
export const initialState: SoilTypeState = adapter.getInitialState({});

export const soilTypeReducer = (state = initialState, action: SoilTypeActions): SoilTypeState => {
  switch (action.type) {
    case SoilTypeActionTypes.LoadSoilTypesSuccess: {
      const sortedSoilTypes = [...action.soilTypes].sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
      );
      return adapter.setAll(sortedSoilTypes, state);
    }

    default: {
      return state;
    }
  }
};
